<div class="container">
    <div class="title">{{data.title |translate}}</div> <br /> <br />
    <div class="subtitle">{{data.subtitle1 |translate }} </div> <br />
    <div class="body">{{data.label11 |translate }}<strong><u>{{data.label12 |translate }}</u></strong>{{data.label13 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle2 |translate }} </div> <br />
    <div class="body">{{data.label2 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle3 |translate }} </div> <br>
    <div class="body">{{data.label3 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle4 |translate }} </div> <br />
    <div class="body">{{data.label4 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle5 |translate }}</div> <br />
    <div class="smallSubtitle">{{data.subtitle5a |translate }}</div> <br />
    <div class="body">{{data.label5a |translate }}</div><br />
    <div class="smallSubtitle">{{data.subtitle5b |translate }}</div> <br />
    <div class="body">{{data.label5b |translate }}</div><br />
    <div class="smallSubtitle">{{data.subtitle5c |translate }}</div> <br />
    <div class="body">{{data.label5c |translate }}</div><br />
    <div class="subtitle">{{data.subtitle6 |translate }} </div> <br />
    <div class="body">{{data.label6 |translate }}</div><br />
    <div class="smallSubtitle">{{data.subtitle6a |translate }}</div> <br />
    <table>
        <tbody>
            <tr>
                <th class="cookieName">{{data.tr1a|translate}}</th>
                <th class="editor">{{data.tr1b|translate}}</th>
                <th class="cookieLifetime">{{data.tr1c|translate}}</th>
                <th class="purpose">{{data.tr1d|translate}}</th>
                <th class="consent">{{data.tr1e|translate}}</th>
            </tr>
            <tr>
                <td class="cookieName">{{data.tr2a|translate}}</td>
                <td class="editor">{{data.tr2b|translate}}</td>
                <td class="cookieLifetime">{{data.tr2c|translate}}</td>
                <td class="purpose">{{data.tr2d|translate}}</td>
                <td class="consent">{{data.tr2e|translate}}</td>
            </tr>
        </tbody>
    </table>
    <br />
    <div class="smallSubtitle">{{data.subtitle6b |translate }}</div> <br />
    <table>
        <tr>
            <th class="cookieName">{{data.tr1a|translate}}</th>
            <th class="editor">{{data.tr1b|translate}}</th>
            <th class="cookieLifetime">{{data.tr1c|translate}}</th>
            <th class="purpose">{{data.tr1d|translate}}</th>
            <th class="consent">{{data.tr1e|translate}}</th>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr3a|translate}}</td>
            <td class="editor">{{data.tr3b|translate}}</td>
            <td class="cookieLifetime">{{data.tr3c|translate}}</td>
            <td class="purpose">
                <tr>{{data.tr3d|translate}}</tr>
                <tr>{{data.tr3d1|translate}}</tr>
                <tr>{{data.tr3d2|translate}}</tr>
            </td>
            <td class="consent">{{data.tr3e|translate}}</td>
        </tr>
    </table>
    <br />
    <div class="smallSubtitle">{{data.subtitle6c |translate }}</div> <br />
    <div class="body">{{data.label6c1 |translate }}<a href="https://www.tousfacteurs.com/">{{data.label6c2 |translate }}</a>{{data.label6c3 |translate }}</div><br />
    <table>
        <tr>
            <th class="cookieName">{{data.tr1a|translate}}</th>
            <th class="editor">{{data.tr1b|translate}}</th>
            <th class="cookieLifetime">{{data.tr1c|translate}}</th>
            <th class="purpose">{{data.tr1d|translate}}</th>
            <th class="consent">{{data.tr1e|translate}}</th>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr4a|translate}}</td>
            <td class="editor">
                <tr>{{data.tr4b|translate}}</tr>
                <tr style="font-style: italic;"><a href="https://fr.matomo.org/privacy-policy/">{{data.tr4b1|translate}}</a></tr>
            </td>
            <td class="cookieLifetime">{{data.tr4c|translate}}</td>
            <td class="purpose">{{data.tr4d|translate}}</td>
            <td class="consent">{{data.tr4e|translate}}</td>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr5a|translate}}</td>
            <td class="editor">
                <tr>{{data.tr5b|translate}}</tr>
                <tr style="font-style: italic;"><a href="https://fr.matomo.org/privacy-policy/">{{data.tr5b1|translate}}</a></tr>
            </td>
            <td class="cookieLifetime">{{data.tr5c|translate}}</td>
            <td class="purpose">{{data.tr5d|translate}}</td>
            <td class="consent">{{data.tr5e|translate}}</td>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr6a|translate}}</td>
            <td class="editor">
                <tr>{{data.tr6b|translate}}</tr>
                <tr style="font-style: italic;"><a href="https://fr.matomo.org/privacy-policy/">{{data.tr6b1|translate}}</a></tr>
            </td>
            <td class="cookieLifetime">{{data.tr6c|translate}}</td>
            <td class="purpose">{{data.tr6d|translate}}</td>
            <td class="consent">{{data.tr6e|translate}}</td>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr7a|translate}}</td>
            <td class="editor">
                <tr>{{data.tr7b|translate}}</tr>
                <tr style="font-style: italic;"><a href="https://fr.matomo.org/privacy-policy/">{{data.tr7b1|translate}}</a></tr>
            </td>
            <td class="cookieLifetime">{{data.tr7c|translate}}</td>
            <td class="purpose">
                <tr>{{data.tr7d|translate}}</tr>
                <tr>{{data.tr7d1|translate}}</tr>
                <tr>{{data.tr7d2|translate}}</tr>
                <tr>{{data.tr7d3|translate}}</tr>
                <tr>{{data.tr7d4|translate}}</tr>
            </td>
            <td class="consent">{{data.tr7e|translate}}</td>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr8a|translate}}</td>
            <td class="editor">{{data.tr8b|translate}}</td>
            <td class="cookieLifetime">{{data.tr8c|translate}}</td>
            <td class="purpose">{{data.tr8d|translate}}</td>
            <td class="consent">{{data.tr8e|translate}}</td>
        </tr>
        <tr>
            <td class="cookieName">{{data.tr9a|translate}}</td>
            <td class="editor">{{data.tr9b|translate}}</td>
            <td class="cookieLifetime">{{data.tr9c|translate}}</td>
            <td class="purpose">{{data.tr9d|translate}}</td>
            <td class="consent">{{data.tr9e|translate}}</td>
        </tr>
    </table>
    <br />
    <div class="subtitle">{{data.subtitle7 |translate }}</div> <br />
    <div class="body">{{data.label7 |translate }}</div><br />
    <div class="subtitle">{{data.subtitle8 |translate }}</div> <br />
    <div class="body">{{data.label8 |translate }}</div><br />
</div>
<div class="button-bar">
    <div class="button" (click)="onNoClick()">retour</div>
</div>